module.exports = __webpack_public_path__ + "img/cms_assets_overview.ac02873d.png";